import { render, staticRenderFns } from "./InscricaoView_v3.vue?vue&type=template&id=f6ce134e&scoped=true"
import script from "./InscricaoView_v3.vue?vue&type=script&lang=js"
export * from "./InscricaoView_v3.vue?vue&type=script&lang=js"
import style0 from "./InscricaoView_v3.vue?vue&type=style&index=0&id=f6ce134e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ce134e",
  null
  
)

export default component.exports